<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="parentFormGroup">
  <div *ngIf="!hideLabel" class="label d-flex justify-content-between">
    <span>
      {{ 'COMPANY_SELECT.COMPANY' | translate }}
    </span>

    <span *ngIf="parentFormGroup.get(passFormControlName).value">
      <button type="button" class="btn btn-ico btn-link" (click)="edit()">
        <i class="fal fa-pencil"></i>
      </button>
    </span>
  </div>

  <ng-container *ngIf="isModal; else outsideModal">
    <ng-select
      [@if]="isInModal"
      (change)="onChange($event)"
      [items]="data"
      bindLabel="abbreviation"
      bindValue="id"
      [loading]="loader"
      [formControlName]="passFormControlName"
      class="colored-select"
      appendTo="body"
    >
      <ng-template ng-typetosearch-tmp>
        <div class="ng-option disabled">
          {{ 'START_TYPING' | translate }}
        </div>
      </ng-template>

      <ng-template ng-label-tmp let-item="item">
        <div class="label-color" [ngStyle]="{ 'background-color': item.color }" *ngIf="item.color"></div>
        {{ item.abbreviation }}
      </ng-template>

      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <div [ngStyle]="{ 'background-color': item.color, color: item.invertColor }" *ngIf="item.color" class="item">
          {{ item.abbreviation }}
        </div>
      </ng-template>

      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
          <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
            <i class="fal fa-plus"></i> {{ 'COMPANY_SELECT.ADD' | translate }}
          </button>
        </div>
      </ng-template>
    </ng-select>
  </ng-container>

  <ng-template #outsideModal>
    <ng-select
      @else
      (change)="onChange($event)"
      [items]="data"
      bindLabel="abbreviation"
      bindValue="id"
      [loading]="loader"
      [formControlName]="passFormControlName"
      appendTo="body"
      class="colored-select"
    >
      <ng-template ng-typetosearch-tmp>
        <div class="ng-option disabled">
          {{ 'START_TYPING' | translate }}
        </div>
      </ng-template>

      <ng-template ng-label-tmp let-item="item">
        <div class="label-color" [ngStyle]="{ 'background-color': item.color }" *ngIf="item.color"></div>
        {{ item.abbreviation }}
      </ng-template>

      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <div [ngStyle]="{ 'background-color': item.color, color: item.invertColor }" *ngIf="item.color" class="item">
          {{ item.abbreviation }}
        </div>
      </ng-template>

      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
          <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
            <i class="fal fa-plus"></i> {{ 'COMPANY_SELECT.ADD' | translate }}
          </button>
        </div>
      </ng-template>
    </ng-select>
  </ng-template>

</div>
